﻿'use strict';


import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];

export default class Launch {

    constructor() {

        if (!d.querySelector("#LocalEventLaunch")) {
            return;
        }


        var jsonData = JSON.parse(mapJsonData);
        var initData = JSON.parse(mapInitPoint);


        if (d.querySelector("#IntroPartnerSlider")) {
            const slider = new Swiper(d.querySelector("#IntroPartnerSlider"), {
                speed: 400,
                spaceBetween: 25,
                slidesPerView: 'auto',
                freeMode: {
                    enabled: true,
                    sticky: true,
                    momentumRatio: 1.5
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }


        let map;
        async function initMap() {
            // The location of Uluru
            const position = { lat: -25.344, lng: 131.031 };
            // Request needed libraries.
            //@ts-ignore
            const { Map } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

            const styledMapType = new google.maps.StyledMapType(
                [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f3fe"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#3247a9"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "weight": 1
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c3cbf8"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#b2c5f7"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ],
                { name: "Styled Map" }
            );



            // The map, centered at Uluru
            map = new Map(document.getElementById("marketMapEmbed"), {
                zoom: 11,
                center: { lat: initData.Latitude, lng: initData.Longitude },
                mapId: "LOCAL_MARKET_MAP"
            });

            map.mapTypes.set("styled_map", styledMapType);
            map.setMapTypeId("styled_map");

            //// The marker, positioned at Uluru
            //const marker = new AdvancedMarkerView({
            //    map: map,
            //    position: position,
            //    title: "Uluru",
            //});

            let infoWindows = [];
            console.log("initting map");

            for (var i = 0; i < jsonData.length; i++) {
                const classItem = jsonData[i];

                const markerImage = document.createElement("img");
                markerImage.src = "/images/pyc/map-icon.png";

                const contentString = `<div class="info-window-content">
                    <div class="pill">${classItem.Activity}</div>
                    <div class="header">${classItem.Title}</div>
                    <p>${classItem.Description}</p>
                    <a href="${classItem.Url}" target="_blank" class="more_info">Sign Up <span class="ada-link">- link opens in a new window</span> <span class="arrow"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="svgStroke" d="M9.77393 1L17 8.22611L9.77393 15.4522" stroke="#0330FE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path class="svgStroke" d="M1 8.22607H11.8392" stroke="#0330FE" stroke-width="1.5" stroke-linecap="round"></path>
                    </svg>
                    </span></a>
                </div>`;

                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 400,
                    ariaLabel: classItem.Title,
                });


                const marker = new AdvancedMarkerView({
                    map: map,
                    position: { lat: classItem.Location.Latitude, lng: classItem.Location.Longitude },
                    title: classItem.Title,
                    content: markerImage
                });

                infoWindows.push(infowindow);

                marker.addListener("click", () => {

                    for (var w = 0; w < infoWindows.length; w++) {
                        infoWindows[w].close();
                    }

                    infowindow.open({
                        anchor: marker,
                        map,
                    });
                });
            }
        }

        initMap();
    }
}